<div class="container">
    <!-- <div *ngIf="isApplyBtnDisabled || isApplyBtnDisabled" class="flex justify-content-center">
      <p-progressSpinner></p-progressSpinner>
    </div> -->
    <p-table
    #headerTable
     [value]="headerTableValue"
     [(selection)]="selectedRow" selectionMode="single" (setPageSize)="setPageSize($event)" [lazy]="true"
      [dataKey]="'doNo'" (tableOnPage)="tablePageChange($event)" (tableOnSort)="tableSort($event)" [rows]="pageInfo.pageSize" [totalRecords]="pageInfo.totalRecords"
      [loading]="isHeaderLoading"
      [scrollable]="true"
      scrollHeight="500px"
      (onRowSelect)="onRowSelect($event)"
      editMode="row"
       [columns]="headerTableColumns"
       class="edittable"
       styleClass="p-datatable-gridlines p-datatable-striped white-space: nowrap;"
       >
       <ng-template pTemplate="caption">
          <button *ngIf="canUploadDoc" pButton pRipple label="{{ 'ShippingStatus.Button.DocUpload' | translate }}" icon="pi pi-file" [disabled]="isDocUploadDisabled()"
          (click)="openFileManagement($event)" class="p-button-success"></button>
          <button pButton pRipple label="{{ 'ShippingStatus.Button.DocReturnApply' | translate }}"icon="pi pi-reply"
            *ngIf="canUploadDoc && isReturnApplyShow && (checkedConfirmStatus === 'F' || checkedConfirmStatus === 'AR')"
            [disabled]="checkedConfirmStatus === 'AR'"
            (click)="doApplyFrontLineDocReturn()"
            class="p-button-danger">
          </button>
          <button pButton pRipple label="{{ 'ShippingStatus.Button.DocReturnReply' | translate }}" icon="pi pi-check-circle"
            *ngIf="canUploadDoc && isReturnReplyShow && checkedConfirmStatus === 'AR'"
            (click)="doReplyFrontLineDocReturn()">
          </button>
          <button *ngIf="canConfirm" pButton pRipple [disabled]="isDocConfirmDisabled()" type="button" label="{{ 'TaskDoc.Button.Confirm' | translate }}" style="float: right" (click)="doConfirm()"></button>

      </ng-template>
        <ng-template pTemplate="colgroup">
          <colgroup>
              <col style="width:10%">
              <col style="width:80%">
              <col style="width:10%">
          </colgroup>
        </ng-template>

      <ng-template pTemplate="header" let-columns>
        <tr>
          <th
            [pSortableColumn]="col.field"
            *ngFor="let col of columns"
            pResizableColumn
            pReorderableColumn
            [attr.field]="col.field">
            {{ col.header | translate}}
            <p-sortIcon [field]="col.field"></p-sortIcon>
          </th>
          <th style="width:8rem"></th>
        </tr>
      </ng-template>
      <ng-template
      pTemplate="body"
      let-rowData
      let-columns="columns"
      let-editing="editing"
      let-rowIndex="rowIndex">
      <tr [pSelectableRow]="rowData" [pEditableRow]="rowData" (click)="clickRow(rowData)" >
        <td *ngFor="let col of columns">
          <ng-container [ngSwitch]="col.field">
            <ng-container *ngSwitchCase="'doNo'">
              <div class="overflow-text">{{ rowData[col.field] | replaceNullWith:'-'}}</div>
            </ng-container>
            <ng-container *ngSwitchCase="'taskList'">
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <p-multiSelect
                    [filter]="true"
                    placeholder="{{ 'Common.DropDown.Select' | translate }}"
                    [options]="taskOptions"
                    appendTo="body"
                    [(ngModel)]="rowData[col.field]"
                    class="p-fluid"
                  >
                  </p-multiSelect>
                </ng-template>
                <ng-template pTemplate="output">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | listOptionsMapping: this.taskOptions
                        | replaceNullWith: "-"
                    }}
                  </div>
                </ng-template>
              </p-cellEditor>
            </ng-container>

          </ng-container>
        </td>

        <td style="text-align:center">
          <ng-container *ngIf="canEditTable">
            <button *ngIf="!editing" [disabled]="isEditing || isConfirmed || !canEditTable" pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil" (click)="onRowEditInit(rowData)" class="p-button-rounded p-button-text"></button>
            <button *ngIf="editing" pButton pRipple type="button" pSaveEditableRow icon="pi pi-check" (click)="onRowEditSave(rowData)" class="p-button-rounded p-button-text p-button-success mr-2"></button>
            <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times" (click)="onRowEditCancel(rowData, rowIndex)" class="p-button-rounded p-button-text p-button-danger"></button>
          </ng-container>
        </td>

      </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="headerTableColumns.length + 1">
            {{ "Common.Table.NoData" | translate }}
          </td>
        </tr>
      </ng-template>

    </p-table>

    <p-table
      [value]="detailTableValue"
      [columns]="detailTableColumns"
      [loading]="isDetailLoading"
      sortMode="multiple"
      styleClass="p-datatable-gridlines p-datatable-striped mt-2"
      class="edittable">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th
            [pSortableColumn]="col.field"
            *ngFor="let col of columns"
            pResizableColumn
            pReorderableColumn
            [attr.field]="col.field">
            {{ col.header | translate}}
            <p-sortIcon [field]="col.field"></p-sortIcon>
          </th>
          <th pResizableColumn pReorderableColumn style="width:7rem">{{ 'ReceiptFormUpload.Download' | translate }}</th>
        </tr>
      </ng-template>

        <ng-template pTemplate="body" let-columns="columns" let-rowData>
          <tr>
            <td *ngFor="let col of columns">
              <ng-container [ngSwitch]="col.field">
                <ng-container *ngSwitchCase="'documentTask'">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | optionsMapping : this.taskOptions
                        | replaceNullWith: "-"
                    }}
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'status'">
                  <div class="overflow-text">
                      {{rowData[col.field]}}
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'docType'">
                  <div class="overflow-text">
                    {{
                      rowData[col.field]
                        | optionsMapping : this.docTypeOptions
                        | replaceNullWith: "-"
                    }}
                  </div>
                </ng-container>

                <ng-container *ngSwitchCase="'fileName'">
                  <div class="overflow-text">
                    {{
                      rowData[col.field] | replaceNullWith:'-'
                    }}
                  </div>
                </ng-container>

                <ng-container *ngSwitchCase="'updateUser'">
                  <div class="overflow-text">
                    {{
                      rowData[col.field] | replaceNullWith:'-'
                    }}
                  </div>
                </ng-container>

                <ng-container *ngSwitchCase="'updateDt'">
                  <div class="overflow-text">
                    {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
                  </div>
                </ng-container>

              </ng-container>
            </td>
            <td style="text-align:center">
              <i *ngIf="rowData.docId" class="pi pi-cloud-download" (click)="downloadFile($event, rowData)"></i>
            </td>
            </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="detailTableColumns.length + 1">
              {{ "Common.Table.NoData" | translate }}
            </td>
          </tr>
        </ng-template>
    </p-table>

  <p-dialog (onShow)="onShowFileManagement($event)" (onHide)="onHideFileManagement($event)" [header]="'DoNo: ' + this.referenceKeys.join(', ')" [style]="{width: '65vw'}" [(visible)]="isShowFileManagement" appendTo="body" [modal]="true" [draggable]="false" [resizable]="false">
    <laas-file-management #fileManagement [fileCategory]="fileCategory" [referenceKeys]="referenceKeys" [limitDocTypes]="limitDocTypes" [uploadFileType]="uploadFileType"></laas-file-management>
  </p-dialog>

  <frontline-docoment-return-confirm-dialog #applyDialog></frontline-docoment-return-confirm-dialog>
  <frontline-docoment-return-confirm-dialog #replyDialog></frontline-docoment-return-confirm-dialog>
</div>
